import React from 'react';

const UploadForm = ({ mode, setmode, formdata, setformdata, selectfile, savebatch, saving }: any) => {
  if (mode != "upload") return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Upload client pack</h3>
          <button className="close-btn" onClick={() => setmode(null)}>&times;</button>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); savebatch(); }}>
          <div className="fg">
            <label>Client</label>
            <input
              type="text"
              value={formdata.clientname}
              onChange={(e) => setformdata({ ...formdata, clientname: e.target.value })}
              required
            />
          </div>
          <div className="fg">
            <label>Period</label>
            <input
              type="month"
              value={formdata.period}
              onChange={(e) => setformdata({ ...formdata, period: e.target.value })}
              required
            />
          </div>
          <div className="fg">
            <label>PDF (bank statements + vouchers, max 15 MB)</label>
            <input
              type="file"
              accept="application/pdf"
              onChange={(e) => selectfile(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
              required
            />
            {formdata.file && <div className="file-note">{formdata.file.name} · {Math.round(formdata.file.size / 1024)} KB</div>}
          </div>
          <button type="submit" className="btn-primary full-width" disabled={saving}>
            {saving ? 'Uploading…' : 'Upload and process'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UploadForm;
